import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { ProductVariantDetailsView } from "@/components/dashboard/buyer/pages/FindSupplierPage"
import { SubmitRfqPage } from "@/components/dashboard/buyer/pages/SubmitRfqPage"
import type { RfqTarget } from "@/components/dashboard/buyer/pages/SubmitRfqPage"
import { useState } from "react"

export const Route = createFileRoute("/explore/products/$productId/variants/$variantId")({
  validateSearch: (search: Record<string, unknown>): {
    companyName?: string
    productName?: string
    variantName?: string
    source?: string
  } => ({
    companyName: (search.companyName as string) || undefined,
    productName: (search.productName as string) || undefined,
    variantName: (search.variantName as string) || undefined,
    source: (search.source as string) || undefined,
  }),
  component: ProductVariantDetailRoute,
})

function ProductVariantDetailRoute() {
  const { productId, variantId } = Route.useParams()
  const { companyName, productName, variantName, source } = Route.useSearch()
  const navigate = useNavigate()
  const [rfqTarget, setRfqTarget] = useState<RfqTarget | null>(null)

  const handleBackToProduct = () => {
    navigate({
      to: "/explore/products/$productId",
      params: { productId },
      search: {
        highlightVariantId: variantId,
        ...(companyName ? { companyName } : {}),
        ...(productName ? { productName } : {}),
        ...(source ? { source } : {}),
      },
      replace: true,
    })
  }

  if (rfqTarget) {
    return (
      <div className="max-w-6xl mx-auto pb-4">
        <SubmitRfqPage
          target={rfqTarget}
          isInline={false}
          onSuccess={() => {
            setRfqTarget(null)
            handleBackToProduct()
          }}
          onCancel={() => setRfqTarget(null)}
        />
      </div>
    )
  }

  return (
    <ProductVariantDetailsView
      variantId={variantId}
      companyName={companyName}
      onBack={handleBackToProduct}
      onRequestQuote={(variant) => {
        setRfqTarget({
          type: "single-product",
          product: {
            ...variant.product,
            id: variant.productId,
            productVariantId: variant.id,
            productName: variant.product?.productName || variant.name,
            name: variant.name,
          },
          companyName,
        })
      }}
    />
  )
}
